import styled from "styled-components";
import { MobileFeatureDescription, MobileFeaturesList } from "../../../../../common/others/features/views/mobile/styled.js";
import { FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const FeaturesMobileWrapper = styled.div.withConfig({
    displayName: "styled__FeaturesMobileWrapper",
    componentId: "sc-c6350f83-0"
})`
	${MobileFeatureDescription} {
		${FontMixin({
    size: 'base',
    weight: 'light',
    height: 'base'
})}
	}

	${MobileFeaturesList} {
		padding: 0px 24px;
	}
`;

//# sourceMappingURL=styled.js.map